function AmazonMappingCtrl($state, $stateParams, $scope, $rootScope, toaster, AmazonMappingService, CommonService) {
  'ngInject';

  const vm = this;
  vm.orgId = $rootScope.orgId;
  vm.mapping = {};
  vm.editMapping = $stateParams.editMapping;
  vm.amazonForm = {};
  vm.accounts = [];
  vm.loading=false;
  if(vm.editMapping){
    vm.editFlag = true;
    vm.amazonForm.debitAccount = vm.editMapping.debit_ac;
    vm.amazonForm.creditAccount = vm.editMapping.credit_ac;
    vm.amazonForm.narration = vm.editMapping.narration;
    vm.amazonForm.name = vm.editMapping.name;
  }
  vm.init = function(){
    vm.loading=true;
      AmazonMappingService.getMappping($stateParams.orgId, function (response) {
        vm.loading = false;
        if(response.status == 200) {
          vm.mapping = response.data;
        }
      });
  };

  vm.getAccounts = function(){
   CommonService.getAccounts($stateParams.orgId, function (response) {
        vm.accounts = response.data;
    });
  }

  $scope.$watch('$root.orgId', function(newValue, oldValue) {
    if(newValue && !oldValue && newValue.id){
     // vm.loadData();
    }
  });

  vm.createMapping = function(amazonMappingForm) {
    vm.responseReceived = false;
      AmazonMappingService.createMapping(vm.amazonForm, $stateParams.orgId, function(response){
        vm.responseReceived = true;
        vm.amazonForm = {};
        amazonMappingForm.$setPristine();
        amazonMappingForm.$setUntouched();
        if(response.status >= 200 & response.status <300) {
          if (vm.editFlag == true) {
            toaster.pop('info', 'Amazon mapping updated.');
          }
          else {
            toaster.pop('info', 'New amazon mapping created.');
          }
          $state.go('user.organization.settingView.mapping.amazon-mapping', {orgId: $stateParams.orgId}, {inherit: false});
        }
        else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
  };

  vm.deleteMapping = function(mappingId) {

  swal({
      title: "Are you sure?",
      text: "Do you want to delete this mapping?",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
  })
  .then(willDelete => {
    if (willDelete) {
      AmazonMappingService.deleteMapping($stateParams.orgId, mappingId, function(response){
          if(response.status == 204){
            vm.mapping = ' ';
            toaster.pop('info', 'Mapping deleted.');
          } else {
            toaster.pop('error', 'Mapping cannot be deleted.');
          }
          $state.go('user.organization.settingView.mapping.amazon-mapping',{orgId: $stateParams.orgId}, {inherit: false});
        });
    }
  });
  };

  vm.editMapping = function (mapping) {
    $state.go('user.organization.settingView.mapping.amazonNewMapping', {orgId: $stateParams.orgId, editMapping: mapping}, {inherit: false});
  };

}

export default{
  name: 'AmazonMappingCtrl',
  fn: AmazonMappingCtrl
}
